module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("bfNSm"))).then(() => parcelRequire('gL6Nj'));